import styled from 'styled-components';

export const StyledThankYouWrapper = styled.div`
    color: #373647;
    font-family: var(--bllink-font-headers);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 70px;
    position: relative;

    .back-btn {
        position: absolute;
        top: 40px;
        right: ${({ ltr }) => ltr ? '' : '20px'};
        left: ${({ ltr }) => ltr ? '20px' : ''};
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 14px;
        font-weight: 700;
        width: fit-content;

        img {
            transform: ${({ ltr }) => ltr ? 'rotate(0deg)' : 'rotate(180deg)'};
        }
    }

    .thanks {
        font-size: 64px;
        margin-bottom: 20px;
    }

    .form-sent {
        font-size: 22px;
        margin-bottom: 40px;
    }

    @media screen and (max-width: 768px) {
        padding: 60px 0 150px;

        .thanks {
            font-size: 32px;
            margin-bottom: 10px;
        }
    
        .form-sent {
            font-size: 16px;
            margin-bottom: 50px;
        }

        .envelope {
            width: 120px;
        }
    }
`
